var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 my-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_orange',
                    to: 'to-selective_yellow',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.pageDescription.text)}}),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image1.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image1.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.firstParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.firstParagraphText.text
                            )}})])],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.secondParagraphSubTitle
                                    .text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'bottom',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.secondParagraphText.text
                            )}})]),_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image2.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image2.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"break-inside-avoid"},[_c('div',{staticClass:"pt-10 xl:pt-14"},[_c('hotspot-richmedia',{staticClass:"-top-2 xl:top-2 -right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'ENR, Le Maroc fait appel au CIH - Hydréole n°58'
                                    ),
                                }}})],1),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .thirdParagraphSubTitle.text
                                )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'right',
                            }}})],1)],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.thirdParagraphText.text
                            )}}),_c('span',{staticClass:"block md:hidden"})]),_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image3.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image3.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"flex flex-col mb-4"},[_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"grid grid-cols-2"},[_c('image-with-descriptions',{staticClass:"object-cover",staticStyle:{"margin":"0"},attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image6.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image6.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}}),_c('image-with-descriptions',{staticClass:"object-cover",staticStyle:{"margin":"0"},attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)]),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'left',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fourthParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fourthParagraphText.text
                            )}})])],1)]),_c('div',{staticClass:"card my-10"},[_c('paragraph',{staticStyle:{"margin-bottom":"0"},attrs:{"options":{
                        color: 'text-nandor',
                    }}},[_c('Dots',{attrs:{"options":{
                            colors: ['#F27E27', '#F15921', '#f15923'],
                        }}}),_c('span',{staticClass:"font-bold text-tundora",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.fifthParagraphText.text)}})],1)],1),_c('div',{staticClass:"container-components mb-4 lg:mb-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'Le bureau d’études à Savoie Technolac'
                                    ),
                                }}}),_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image7.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image7.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fifthParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sixthParagraphText.text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sixthParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.eigthParagraphText.text
                            )}})]),_c('image-with-descriptions',{staticClass:"object-cover",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image8.src,
                            descriptions: [],
                        }}}),_c('div',{staticClass:"\n                            absolute\n                            inline-block\n                            w-auto\n                            bottom-2\n                            lg:bottom-10\n                            -right-10\n                            lg:lg:-right-14 xl:font-bold\n                            transform\n                            text-white text-right text-xs\n                            xl:text-base\n                            origin-bottom-right\n                            xl:origin-top-right\n                            -translate-x-full\n                        "},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.currentPage.images.image8.text)}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('article-note',{staticClass:"overflow-hidden",attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.verticalText.text,

                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-selective_yellow',
                            },
                            fontSize: {
                                verticalcontent: 'text-2xl xl:text-3xl',
                            },
                            margin: {},
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image9.src,
                        }}}),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.seventhParagraphSubTitle
                                    .text
                            )}})],1),_c('span',{staticClass:"text-nandor",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.ninthParagraphText.text)}}),_c('paragraph',{staticStyle:{"margin":"0"},attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"\n                                m-0\n                                text-cornflower_blue\n                                text-5xl\n                                lg:text-7xl\n                                2xl:text-8xl\n                            ",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.tenthParagraphText.text
                            )}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.twelfthParagraphText
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.eleventhParagraphText
                                    .text
                            )}})])],1)]),_c('div',{staticClass:"container-components md:my-7 p-2.5",staticStyle:{"background-color":"#f2f2f2"}},[_c('div',{staticClass:"card "},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'right',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.eigthParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.thirteenParagraphText
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image10.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.image10
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"mx-auto w-full"},[_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image11.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.image11.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)]),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card",staticStyle:{"padding":"0"}},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.nineParagraphSubTitle
                                    .text
                            )}})],1),_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.image12.src,
                                descriptions: [],
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fourteenParagraphText
                                    .text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid",staticStyle:{"padding":"0"}},[_c('div',{},[_c('hotspot-richmedia',{staticClass:"top-0 -right-6 2xl:-right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Screening, la quête du spot idéal'
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_orange',
                            to: 'to-selective_yellow',
                        }}},[_c('Triangles',{staticStyle:{"margin":"0","margin-right":"0.25rem"},attrs:{"options":{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.ninthParagraphSubTitle
                                    .text
                            )}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.fiftheenParagraphText
                                    .text
                            )}})]),_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.image13.src,
                            descriptions: [],
                        }}})],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }